"use strict";
// CRITICAL NOTE: this code may be redundant
Object.defineProperty(exports, "__esModule", { value: true });
exports.getTreasuryHoldings = getTreasuryHoldings;
exports.putTreasuryDataToDynamoDb = putTreasuryDataToDynamoDb;
exports.putAlphaHoldersToDnamoDb = putAlphaHoldersToDnamoDb;
exports.getTreasuryDataFromDynamoDb = getTreasuryDataFromDynamoDb;
exports.getAlphaHoldersFromDynamoDb = getAlphaHoldersFromDynamoDb;
const alphafi_sdk_1 = require("@alphafi/alphafi-sdk");
const decimal_js_1 = require("decimal.js");
const client_dynamodb_1 = require("@aws-sdk/client-dynamodb");
const lib_dynamodb_1 = require("@aws-sdk/lib-dynamodb");
const logger_js_1 = require("../../logger.js");
const HOLDERS_CONF_TABLE_NAME = process.env.HOLDERS_CONF_TABLE_NAME;
// TODO: formalise the dynamoDB functions (add boiler plate for error handling)
async function getTreasuryHoldings() {
    const treasuryAddress = (0, alphafi_sdk_1.getConf)().TREASURY_ADDRESS;
    // get the xtokens from receipts
    const xtokensHoldings = [];
    for (const poolName in alphafi_sdk_1.poolInfo) {
        const poolReceipts = await (0, alphafi_sdk_1.getReceipts)(poolName, treasuryAddress, false);
        if (poolReceipts.length === 0)
            continue;
        xtokensHoldings.push({
            owner: treasuryAddress,
            poolName: poolName,
            holding: poolReceipts
                .reduce((xtokensTotal, receipt) => {
                return xtokensTotal.add(receipt.content.fields.xTokenBalance);
            }, new decimal_js_1.Decimal(0))
                .toString(),
        });
    }
    // get the tokens from xtokens
    const tokenHoldings = await (0, alphafi_sdk_1.multiLiquidityToTokens)(await (0, alphafi_sdk_1.multiXTokensToLiquidity)(xtokensHoldings));
    // get the usd holdings
    const usdHoldings = await (0, alphafi_sdk_1.multiTokensToUsd)(tokenHoldings);
    // map to treasury holding object
    const treasuryHoldings = {};
    tokenHoldings.map((tokenHolding) => {
        const poolName = tokenHolding.poolName;
        const address = tokenHolding.user;
        if ("tokens" in tokenHolding) {
            const usdBalance = {
                address: address,
                tokens: tokenHolding.tokens,
                usdBalance: usdHoldings.find((usdHolding) => usdHolding.poolName === poolName).holding,
            };
            treasuryHoldings[poolName] = usdBalance;
        }
        else if ("tokenAmountA" in tokenHolding) {
            const usdBalance = {
                address: address,
                tokensA: tokenHolding.tokenAmountA,
                tokensB: tokenHolding.tokenAmountB,
                usdBalance: usdHoldings.find((usdHolding) => usdHolding.poolName === poolName).holding,
            };
            treasuryHoldings[poolName] = usdBalance;
        }
        else {
            (0, logger_js_1.logError)("Unexpected holding format found in treasury holdings", {
                component: "holders",
                operation: "getTreasuryHoldings",
                context: { tokenHolding },
            });
            throw new Error("Unexpected holding found");
        }
    });
    treasuryHoldings["TOTAL"] = {
        address: treasuryAddress,
        totalUsdBalance: usdHoldings
            .reduce((total, holdingObj) => {
            return total.add(new decimal_js_1.Decimal(holdingObj.holding));
        }, new decimal_js_1.Decimal(0))
            .toString(),
    };
    return treasuryHoldings;
}
async function putTreasuryDataToDynamoDb(params) {
    const tableName = params.tableName
        ? params.tableName
        : HOLDERS_CONF_TABLE_NAME;
    const ddbClient = params.ddbClient
        ? params.ddbClient
        : new client_dynamodb_1.DynamoDBClient({ region: process.env.AWS_REGION });
    const ddbDocClient = lib_dynamodb_1.DynamoDBDocumentClient.from(ddbClient);
    const item = {
        id: "statsPage#treasuryHoldings",
        treasuryHoldings: params.treasuryHoldings,
    };
    const command = new lib_dynamodb_1.PutCommand({
        TableName: tableName,
        Item: item,
    });
    await ddbDocClient.send(command);
}
async function putAlphaHoldersToDnamoDb(params) {
    const tableName = params.tableName
        ? params.tableName
        : HOLDERS_CONF_TABLE_NAME;
    const ddbClient = params.ddbClient
        ? params.ddbClient
        : new client_dynamodb_1.DynamoDBClient({ region: process.env.AWS_REGION });
    const ddbDocClient = lib_dynamodb_1.DynamoDBDocumentClient.from(ddbClient);
    const item = {
        id: "statsPage#alphaHolders",
        alphaHolders: params.alphaHolders,
    };
    const command = new lib_dynamodb_1.PutCommand({
        TableName: tableName,
        Item: item,
    });
    await ddbDocClient.send(command);
}
async function getTreasuryDataFromDynamoDb(params) {
    const tableName = params.tableName
        ? params.tableName
        : HOLDERS_CONF_TABLE_NAME;
    const ddbClient = params.ddbClient
        ? params.ddbClient
        : new client_dynamodb_1.DynamoDBClient({ region: process.env.AWS_REGION });
    const ddbDocClient = lib_dynamodb_1.DynamoDBDocumentClient.from(ddbClient);
    const command = new lib_dynamodb_1.GetCommand({
        TableName: tableName,
        Key: {
            id: "statsPage#treasuryHoldings",
        },
    });
    const result = await ddbDocClient.send(command);
    if (result.Item) {
        return result.Item["treasuryHoldings"];
    }
    else {
        throw new Error("Treasury data not found");
    }
}
async function getAlphaHoldersFromDynamoDb(params) {
    const tableName = params.tableName
        ? params.tableName
        : HOLDERS_CONF_TABLE_NAME;
    const ddbClient = params.ddbClient
        ? params.ddbClient
        : new client_dynamodb_1.DynamoDBClient({ region: process.env.AWS_REGION });
    const ddbDocClient = lib_dynamodb_1.DynamoDBDocumentClient.from(ddbClient);
    const command = new lib_dynamodb_1.GetCommand({
        TableName: tableName,
        Key: {
            id: "statsPage#alphaHolders",
        },
    });
    const result = await ddbDocClient.send(command);
    if (result.Item) {
        return result.Item["alphaHolders"];
    }
    else {
        throw new Error("alpha holders not found");
    }
}
//# sourceMappingURL=holders.js.map